<template>
  <div>
    <h1>Change Ownership</h1>
    <hr>
    <!-- FILTER START -->
    <panel class="border border-secondary" :noExpand="true">
      <template slot="header">
        <h4 class="panel-title">Filter Option</h4>
      </template>
      <div class="row outerBox filterBox">
          <div class="col row">
              <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
                <label for="search_by">Search By</label>
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <button class="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{{ filterOptChosen.text }}&nbsp;<i class="fas fa-caret-down"></i></button>
                    <div class="dropdown-menu">
                      <a class="dropdown-item" v-for="opt in filterOpt" @click="filterOptChosen = opt">{{ opt.text }}</a>
                    </div>
                  </div>
                  <input v-model="keyword" type="text" class="form-control" aria-label="Text input with dropdown button">
                </div>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
                <label for="dateTimeInput">From</label>
                <flat-pickr
                  v-model="filter.start"
                  :config="seperatedRangeConfig"
                  placeholder="Select From Date"
                />
              </div>
              <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
                <label for="dateTimeInput">To</label>
                <flat-pickr
                  v-model="filter.end"
                  :config="seperatedRangeConfig"
                  placeholder="Select To Date"
                />
              </div>
              <div class="col-12 row">
                <div class="col-md-4 mt-2">
                  <button class="btn btn-primary w-100" type="button" @click="vue_universal_table.update++">
                    <span class="fa fa-filter"></span>&nbsp;&nbsp;Search
                  </button>
                </div>
                <div class="col-md-4 mt-2">
                  <button class="btn btn-success w-100" type="button" @click="downloadExcel()">
                    <span class="fa fa-file-excel"></span>&nbsp;&nbsp;Export To Excel
                  </button>
                </div>
              </div>
          </div>
      </div>
    </panel>
    <!-- FILTER END -->

    <vue-universal-table
      :api_url="'/api/reports/change-ownership'"
      :filter="filter"
      :fields="vue_universal_table.fields"
      :update="vue_universal_table.update"
      :infinite_scroll="true"
    ></vue-universal-table>

  </div>
</template>

<script>
  import flatPickr from 'vue-flatpickr-component'
  import moment from 'moment'

  export default {
    data () {
      const startOfMonth = moment().startOf('month').format('YYYY-MM-DD');
      const endOfMonth   = moment().format('YYYY-MM-DD');
      return {
        rangeConfig: {
          mode: 'range',
          altInput: true,
          altInputClass: 'form-control input flatpickr-input',
          animate: !this.isRTL(),
        },
        seperatedRangeConfig: {
          altInput: true,
          altInputClass: 'form-control input flatpickr-input',
          animate: !this.isRTL(),
        },
        filterOpt: [
          {
            
            text: 'QR Code',
            value: 'qrcode'
          }, {
            text: 'Engine Number',
            value: 'engine_no'
          }, {
            text: 'Frame Number',
            value: 'frame_no'
          }
        ],
        filterOptChosen : {
          text: 'QR Code',
          value: 'qrcode'
        },
        filter : {
          start : '',
          end : ''
        },
        keyword : '',
        vue_universal_table : {
          fields : [
            {
              title : 'Engine No',
              variable : 'engine_no'
            },
            {
              title : 'Frame Number',
              variable : 'frame_no'
            },
            {
              title : 'QR Code',
              variable : 'qrcode'
            },
            {
              title : 'Old Owner',
              variable : 'old_owner'
            },
            {
              title : 'New Owner',
              variable : 'new_owner'
            },
            {
              title : 'Change Date',
              variable : 'change_date'
            }
          ],
          update : 0,
        },
        // range: `${startOfMonth} to ${endOfMonth}`,
        error: '',
        rangeConfig: {
          mode: 'range',
          altInput: true,
          animate: !this.isRTL()
        },
      }
    },
    components : {
      flatPickr
    },
    mounted () {

    },
    watch : {
      filterOptChosen : {
        handler(){
          for(var i = 0; i < this.filterOpt.length; i++){
            delete this.filter[this.filterOpt[i].value]
          }
          this.keyword = ''
        },
        deep : true,
      },
      keyword : {
        handler(){
          this.filter[this.filterOptChosen.value] = this.keyword
        }
      },
      range : {
        handler(){
          let splitDateRange = this.range.split(' to ');
          this.filter.start = splitDateRange[0]
          this.filter.end = splitDateRange[1]
        },
        immediate : true
      }
    },
    methods : {
      async downloadExcel (filter) {
        if (this.range == '') {
          this.error = "Please Select Time Range To Download The Excel"
          return;
        }
        let url = '/api/reports/change-ownership/download-excel?' + await this.initialiseFilter()

        this.$http.get(url , {responseType : 'blob'})
        .then((resp)=>{
          const blob = new Blob([resp.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          });
          var a = document.createElement("a");
          document.body.appendChild(a);
          a.style = "display: none";
          let url = window.URL.createObjectURL(blob);
          a.href = url;
          a.download = "Change Ownership Data (" + this.range + ")";
          a.click();
          window.URL.revokeObjectURL(url);
        })
        .catch((err)=>{
          console.log(err);
        })
      },
      initialiseFilter(){
        if(!(typeof this.filter === 'object' && this.filter !== null)){
          this.filterUrl = '';
          return;
        }
        var keys = Object.keys(this.filter);
        let stringUrl = '';
        var queryParams = this.filter;

        for(var i = 0 ; i < keys.length; i++){
          if(!queryParams[keys[i]])
            continue;

          if(queryParams[keys[i]] == '' || queryParams[keys[i]].length == 0)
            continue 

          if((keys[i] == 'user_type') && queryParams[keys[i]] == 'All')
            continue;
          
          // if(keys[i] == 'start_hour' || keys[i] == 'end_hour')
          //   queryParams[keys[i]] += ":00";

          stringUrl += `&${keys[i]}=${queryParams[keys[i]]}`;
          
        }
        return stringUrl;
      },
    //   generateData () {
    //     var data = []
        
    //     for(var i = 0; i < 100; i++) {
    //       data.push({
    //         engine_number : this.randomInt(0,100000000000),
    //         frame_number : this.randomInt(0,100000000000),
    //         qr_code : this.randomInt(0,100000000000),
    //         old_owner : 'XXXXXXXXXXXXXXX',
    //         new_owner : 'XXXXXXXXXXXXXXX',
    //       })
    //     }

    //     this.data = data;
    //   }
    }
  }
</script>

<style scoped>
  
</style>